import { Component } from "react";
import { observer } from "mobx-react";

import type { Message, ToolApprovalDecision } from "../models.ts";
import { ImgWarning } from "./Images/ImgWarning.tsx";

type ChatMessageToolApprovalProps = {
  message: Message;
  pendingToolApprovalName?: string | null;
  toolApprovalDecision?: ToolApprovalDecision | null;
  onToolApprovalDecision?: (toolName: string, decision: ToolApprovalDecision) => void;
};

@observer
export class ChatMessageToolApproval extends Component<ChatMessageToolApprovalProps> {
  render() {
    let { message } = this.props;
    const { pendingToolApprovalName, onToolApprovalDecision } = this.props;

    if (message.collapsedMessages && !message.pendingToolApproval) {
      message = [...message.collapsedMessages].reverse().find(m => m.pendingToolApproval) || message;
    }

    const { toolApprovalDecision, pendingToolApproval } = message;
    const isPending = !!pendingToolApprovalName;
    const shouldShow = isPending || this.props.toolApprovalDecision;

    if (!isPending || !pendingToolApproval || !shouldShow) return null;

    if (toolApprovalDecision && !isPending) {
      const toolName = message.toolsFunctionName;
      const decisionText = toolApprovalDecision === 'allow' ? 'Allowed' : 'Denied';
      const decisionClass = toolApprovalDecision === 'allow' ? 'approval-summary-allowed' : 'approval-summary-denied';

      return (
        <div className={`tool-approval-summary ${decisionClass}`}>
          <span className="tool-approval-summary-text">Tool {toolName}: {decisionText}</span>
        </div>
      );
    }

    return (
      <div className="tool-approval-container">
        <div className="tool-approval-header">
          <span className="tool-approval-icon"><ImgWarning size={16} /></span>
          <span className="tool-approval-title">MCP Tool Approval Required</span>
        </div>
        <div className="tool-approval-details">
          <div className="tool-approval-info">
            <span className="tool-approval-label">Server:</span>
            <span className="tool-approval-value">{pendingToolApproval.serverName}</span>
          </div>
          <div className="tool-approval-info">
            <span className="tool-approval-label">Tool:</span>
            <span className="tool-approval-value">{pendingToolApproval.toolName}</span>
          </div>
          {pendingToolApproval.arguments && (
            <div className="tool-approval-arguments">
              <span className="tool-approval-label">Arguments:</span>
              <pre className="tool-approval-args-code">{pendingToolApproval.arguments}</pre>
            </div>
          )}
        </div>
        <div className="tool-approval-actions">
          <button
            className="tool-approval-btn tool-approval-deny"
            onClick={() => onToolApprovalDecision?.(pendingToolApproval.toolName, 'deny')}
          >
            Deny
          </button>
          <button
            className="tool-approval-btn tool-approval-allow"
            onClick={() => onToolApprovalDecision?.(pendingToolApproval.toolName, 'allow')}
          >
            Allow
          </button>
          <button
            className="tool-approval-btn tool-approval-always"
            onClick={() => onToolApprovalDecision?.(pendingToolApproval.toolName, 'always-allow')}
          >
            Always Allow
          </button>
        </div>
      </div>
    );
  }
}
